// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import "core-js/stable";
import "regenerator-runtime/runtime";

require("@rails/ujs").start();
require("@hotwired/turbo-rails")
require("channels");

import "../controllers/index";

import "../controllers/frontend/index";
import "../controllers/index";

import "./animated_counter";
import "./collapsible";
import "./smooth_scroll";
import "./splide";
import setLocalTime from "./local_time";
import "stylesheets/application";

setLocalTime();

document.addEventListener("turbo:load", () => {
  lucide.createIcons();
});